import { TipoNormativaI } from "interfaces/TipoNormativa";

export interface infoFetchTipoNormativaI {
  id: number | string;
  nombre: string;
}

class TipoNormativa implements TipoNormativaI {
  id: number | string;
  nombre: string;

  constructor(infoFetch: infoFetchTipoNormativaI) {
    this.id = infoFetch.id;
    this.nombre = infoFetch.nombre;
  }
}

export const makeTipoNormativa = (infoFetch: infoFetchTipoNormativaI) => {
  return new TipoNormativa(infoFetch);
};
